import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
import ReactPlayer from "react-player";
import Slider from "react-slick";
import jhakanaka from "../../Assets/Images/starProfile/Music-Wase.gif";
import "./PromoVideo.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { serverInfo } from "../../App";

const PromoVideo = () => {


  const { videoCdnUrl } = useContext(serverInfo);

  const [promoVideos, setPromoVideos] = useState([]);

  useEffect(() => {
    if (localStorage.auth_token) {
      axios.get(`/api/user/PromoVideos`).then((res) => {
        if (res.data.status == 200) {
          setPromoVideos(res.data.promoVideos);
        }
      });
    } else {
      axios.get(`/api/guest/PromoVideos`).then((res) => {
        if (res.data.status == 200) {
          setPromoVideos(res.data.promoVideos);
        }
      });
    }
  }, []);

  const NextArrow = ({ onClick }) => {
    return (
      <div className="arrow Tvr next" onClick={onClick}>
        <span className="prf">
          <FaArrowRight />
        </span>
      </div>
    );
  };

  const PrevArrow = ({ onClick }) => {
    return (
      <div className="arrow Tvr prev" onClick={onClick}>
        <span className="prf">

          <FaArrowLeft />
        </span>
      </div>
    );
  };

  const [videoIndex, setVideoIndex] = useState(0);

  const settings = {
    autoplay: true,
    vertical:false,
    infinite: false,
    focusOnSelect: true,
    lazyLoad: true,
    slidesToShow: 1,
    centerMode: true,
    centerPadding: 0,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    beforeChange: (current, next) => setVideoIndex(next),
  };

  if(promoVideos.length === 0){
    return null;
  }

  return (
    <div className="mt-3 bg-gray promoSlider">
      <Slider className="bg-gray" {...settings}>
        {promoVideos.map((video, i) => (
          <div className="bg-gray">
            <div
              className={
                i === videoIndex
                  ? "slide activeSlide videoCard"
                  : "slide videoCard"
              }
            >

              <ReactPlayer
                url={videoCdnUrl + video.video_url}
                playing={i === videoIndex ? true : false}
                muted={true}
                controls={true}
                width="100%"
                height="25vh"
                className="VideoPro"
              />
            </div>
          </div>
        ))}
      </Slider>
      <img src={jhakanaka} className="img-fluid" alt="" />
    </div>
  );
};

export default PromoVideo;
